import { useEffect, useRef } from 'react'

import { getCountryByIP } from '@/models/auth/ports'
import useLocalStorage from '@/hooks/use-localstorage'

interface UserLocation {
  country_code_alpha2: string
  country_name: string
  state: string
  city: string
  city_confidence: number | null
  loaded?: boolean
  message?: string
}

export const useGeoIpLocation = (): UserLocation => {
  const loadedRef = useRef(false)
  const [userLocation, setUserLocation] = useLocalStorage('userLocation', {})

  useEffect(() => {
    if (loadedRef.current || userLocation.loaded) return

    const getUserLocation = async () => {
      try {
        const { body }: { body: UserLocation } = (await getCountryByIP()) || {}
        await setUserLocation({ ...body, loaded: true })
        loadedRef.current = true
      } catch (error) {
        console.error('Error fetching user location:', error)
      }
    }
    getUserLocation()
  }, [])

  return userLocation
}
